(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hc-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.hcProductCardQtyReady) return;
  window.hcProductCardQtyReady = true;

  function clampQty(input, next) {
    var min = 0;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
    if (isNaN(max)) max = Infinity;
    if (next < min) next = min;
    if (next > max) next = max;
    return next;
  }

  function syncSubmit(wrap, value) {
    var form = wrap.closest('product-form') || wrap.closest('form');
    if (!form) return;
    var submit = form.querySelector('[type="submit"]');
    if (!submit) return;
    if (submit.querySelector('.sold-out-message') && !submit.querySelector('.sold-out-message').classList.contains('hidden') && submit.hasAttribute('aria-disabled')) {
      return;
    }
    submit.disabled = value < 1;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-hc-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-hc-qty-wrap]');
    if (!wrap) return;
    var input = wrap.querySelector('[data-hc-qty-input]');
    if (!input) return;
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 0;
    var step = parseInt(input.getAttribute('step'), 10) || 1;
    var ruleMin = parseInt(input.getAttribute('data-hc-qty-rule-min'), 10) || 1;
    var next = current;
    if (btn.getAttribute('data-hc-qty') === 'plus') {
      next = current < 1 ? ruleMin : current + step;
    } else if (current <= ruleMin) {
      next = 0;
    } else {
      next = current - step;
    }
    next = clampQty(input, next);
    input.value = next;
    syncSubmit(wrap, next);
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest('[data-hc-qty-input]');
    if (!input) return;
    var wrap = input.closest('[data-hc-qty-wrap]');
    if (!wrap) return;
    var next = parseInt(input.value, 10);
    if (isNaN(next) || next < 0) next = 0;
    next = clampQty(input, next);
    input.value = next;
    syncSubmit(wrap, next);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
